import type { Category } from "./schema";

/**
 * Default taxonomy shipped with BudgetOS.
 * Survives "Clear All Data" and is restored as configuration (not personal data).
 */
export const DEFAULT_CATEGORIES: Category[] = [
  { id: "cat-sal", name: "Salary", type: "income", group: "income", monthlyTarget: 5500, icon: "💼", color: "mint" },
  { id: "cat-side", name: "Side Hustle", type: "income", group: "income", monthlyTarget: 800, icon: "⚡", color: "lemon" },
  { id: "cat-div", name: "Dividends", type: "income", group: "income", monthlyTarget: 200, icon: "📈", color: "sky" },
  { id: "cat-rent", name: "Rent / Mortgage", type: "expense", group: "needs", monthlyTarget: 1400, icon: "🏠", color: "lavender" },
  { id: "cat-util", name: "Utilities", type: "expense", group: "needs", monthlyTarget: 180, icon: "💡", color: "lavender" },
  { id: "cat-groc", name: "Groceries", type: "expense", group: "needs", monthlyTarget: 400, icon: "🛒", color: "lavender" },
  { id: "cat-ins", name: "Insurance", type: "expense", group: "needs", monthlyTarget: 220, icon: "🛡️", color: "lavender" },
  { id: "cat-trans", name: "Transport", type: "expense", group: "needs", monthlyTarget: 150, icon: "🚌", color: "lavender" },
  { id: "cat-health", name: "Health", type: "expense", group: "needs", monthlyTarget: 90, icon: "❤️", color: "coral" },
  { id: "cat-eat", name: "Dining Out", type: "expense", group: "wants", monthlyTarget: 200, icon: "🍜", color: "lemon" },
  { id: "cat-ent", name: "Entertainment", type: "expense", group: "wants", monthlyTarget: 100, icon: "🎬", color: "lemon" },
  { id: "cat-shop", name: "Shopping", type: "expense", group: "wants", monthlyTarget: 150, icon: "🛍️", color: "lemon" },
  { id: "cat-sub", name: "Subscriptions", type: "expense", group: "wants", monthlyTarget: 60, icon: "📺", color: "lemon" },
  { id: "cat-travel", name: "Travel", type: "expense", group: "wants", monthlyTarget: 200, icon: "✈️", color: "sky" },
  { id: "cat-emerg", name: "Emergency Fund", type: "expense", group: "savings", monthlyTarget: 300, icon: "🏦", color: "mint" },
  { id: "cat-invest", name: "Investments", type: "expense", group: "savings", monthlyTarget: 500, icon: "📊", color: "mint" },
  { id: "cat-ret", name: "Retirement (401k)", type: "expense", group: "savings", monthlyTarget: 400, icon: "🌅", color: "mint" },
];

export function defaultCategoryIds(): string[] {
  return DEFAULT_CATEGORIES.map((c) => c.id);
}

/** Pure check used by tests — categories match the default set by id. */
export function matchesDefaultCategories(cats: { id: string }[]): boolean {
  if (cats.length !== DEFAULT_CATEGORIES.length) return false;
  const ids = new Set(cats.map((c) => c.id));
  return DEFAULT_CATEGORIES.every((c) => ids.has(c.id));
}
